export const FETCH_ACTIVATION_RATIO_DATA = "FETCH_ACTIVATION_RATIO_DATA";
export const SET_ACTIVATION_RATIO_DATA = "SET_ACTIVATION_RATIO_DATA";
